export default "__VITE_ASSET__oOyU8kyv__"